import mirrorCreator from 'mirror-creator';
import { createActions } from 'redux-actions';

const actionTypes = mirrorCreator([
  'OFF_RAMPS_REQUEST',
  'OFF_RAMPS_SUCCESS',
  'OFF_RAMPS_FAILURE',
  'OFF_RAMPS_TABLE_NEXT_PAGE',
  'OFF_RAMPS_TABLE_PREVIOUS_PAGE',
  'RESET_OFF_RAMPS_TABLE',
  'RESET_OFF_RAMPS_TABLE_PAGE',
  'SET_OFF_RAMPS_TABLE_FILTER',
  'SET_OFF_RAMPS_TABLE_PAGE',
  'SET_OFF_RAMPS_TABLE_PAGE_SIZE',
  'SET_OFF_RAMPS_TABLE_SORT',
  'SINGLE_OFF_RAMP_REQUEST',
  'SINGLE_OFF_RAMP_SUCCESS',
  'SINGLE_OFF_RAMP_FAILURE',
  'CREATE_OFF_RAMP_BILL_REQUEST',
  'CREATE_OFF_RAMP_BILL_SUCCESS',
  'CREATE_OFF_RAMP_BILL_FAILURE',
]);

const actionCreators = createActions(
  {
    [actionTypes.OFF_RAMPS_FAILURE]: Error,
    [actionTypes.SINGLE_OFF_RAMP_FAILURE]: Error,
    [actionTypes.CREATE_OFF_RAMP_BILL_FAILURE]: Error,
  },
  actionTypes.OFF_RAMPS_REQUEST,
  actionTypes.OFF_RAMPS_SUCCESS,
  actionTypes.OFF_RAMPS_TABLE_NEXT_PAGE,
  actionTypes.OFF_RAMPS_TABLE_PREVIOUS_PAGE,
  actionTypes.RESET_OFF_RAMPS_TABLE,
  actionTypes.RESET_OFF_RAMPS_TABLE_PAGE,
  actionTypes.SET_OFF_RAMPS_TABLE_FILTER,
  actionTypes.SET_OFF_RAMPS_TABLE_PAGE,
  actionTypes.SET_OFF_RAMPS_TABLE_PAGE_SIZE,
  actionTypes.SET_OFF_RAMPS_TABLE_SORT,
  actionTypes.SINGLE_OFF_RAMP_REQUEST,
  actionTypes.SINGLE_OFF_RAMP_SUCCESS,
  actionTypes.CREATE_OFF_RAMP_BILL_REQUEST,
  actionTypes.CREATE_OFF_RAMP_BILL_SUCCESS
);

export default {
  ...actionTypes,
  ...actionCreators,
};
